/**
 * Settings keys used for remote config and localStorage.
 */
export enum SETTINGS_KEYS {
    THEME = "THEME",
    COLOR_SCHEME = "COLOR_SCHEME",
    LANGUAGE = "LANGUAGE",
    DATE_FORMAT = "DATE_FORMAT",
    TIME_FORMAT = "TIME_FORMAT",
    DARWIN_AI_ENABLED = "DARWIN_AI_ENABLED",
    AI_ANALYSIS_ENABLED = "AI_ANALYSIS_ENABLED",
    DIALER_VOLUME = "DIALER_VOLUME",
    SELECTED_BRAND = "SELECTED_BRAND",
    SIDEBAR_COLLAPSED = "SIDEBAR_COLLAPSED",
    HAS_SEEN_TOUR = "HAS_SEEN_TOUR",
    OUTGOING_CALL_MELODY_MUTE = "OUTGOING_CALL_MELODY_MUTE",
    DASHBOARD_HIDDEN_MAP = "DASHBOARD_HIDDEN_MAP",
    DASHBOARD_COLUMN_LAYOUT = "DASHBOARD_COLUMN_LAYOUT",
    PINNED_TEAM_MEMBERS = "PINNED_TEAM_MEMBERS",
    PINNED_TEAM_MEMBERS_PRESETS = "PINNED_TEAM_MEMBERS_PRESETS",
    PINNED_TEAM_MEMBERS_CURRENT_PRESET = "PINNED_TEAM_MEMBERS_CURRENT_PRESET",
    DASHBOARD_PINNED_MEMBERS_PRESETS = "DASHBOARD_PINNED_MEMBERS_PRESETS",
    DASHBOARD_QUALITY_WATCH_PRESETS = "DASHBOARD_QUALITY_WATCH_PRESETS",
    QUALITY_WATCH_PRESETS = "QUALITY_WATCH_PRESETS",
    QUALITY_WATCH_CURRENT_PRESET = "QUALITY_WATCH_CURRENT_PRESET",
    CUSTOM_LINKS = "CUSTOM_LINKS",
    /** Department keys shown in the Priority Report widget (e.g. ["de", "it"]). */
    PRIORITY_REPORT_DEPARTMENTS = "PRIORITY_REPORT_DEPARTMENTS",
    CALENDAR_CAPACITIES_VISIBLE = "CALENDAR_CAPACITIES_VISIBLE",
    SELECTED_DASHBOARD = "SELECTED_DASHBOARD",
    /** Setting list filters for the Leads page (selected team + custom filters). */
    SETTING_LIST = "SETTING_LIST",
    /** Widgets, order and sizes of the customizable home dashboard. */
    HOME_DASHBOARD_LAYOUT = "HOME_DASHBOARD_LAYOUT",
}
